module.exports = __webpack_public_path__ + "img/lake_floorplan.beffa7f1.svg";